import { styled } from "styled-components";

export const ProductInfo = styled.div`
  display: flex;
  align-items: center;
  padding: 16px 14px 14px;
  height: 48px;
  background-color: #ececec;
  color: gray;
  border-radius: 3px;
`;
